/**
 * Client wrappers for the Feedback tab's callables
 * (functions/src/handlers/feedback/suiteFeedbackHandlers.ts). Errors
 * propagate as Firebase HttpsError (err.code: "resource-exhausted",
 * "permission-denied", "invalid-argument"...).
 */
import { callable } from "../../firebase.js";

const call = async (name, payload, options) => {
  const result = await callable(name, options)(payload);
  return result.data;
};

export const feedbackApi = {
  /** { type, message, pictureState, picture?, context } → { id, picture } */
  submit: (payload) => call("submitSuiteFeedback", payload, { timeout: 60_000 }),
  /** → { items, truncated } (admins only) */
  list: () => call("listSuiteFeedback", {}),
  /** → { open, bugs } (admins only) */
  countOpen: () => call("listSuiteFeedback", { countOnly: true }),
  /** { id } → one report in full (admins only; the list carries summaries) */
  get: ({ id }) => call("getSuiteFeedback", { id }),
  /** { id, status?, note? } → the updated item (admins only) */
  update: (payload) => call("updateSuiteFeedback", payload),
  /** { id } → { jpegBase64, bytes } (admins only) */
  getPicture: ({ id }) => call("getSuiteFeedbackPicture", { id }),
  /** { id } → { ok } (admins only) */
  deletePicture: ({ id }) => call("deleteSuiteFeedbackPicture", { id }),
};

/** Plain words for a failed send. */
export function submitErrorText(e) {
  const code = typeof e?.code === "string" ? e.code.replace(/^functions\//, "") : "";
  if (code === "resource-exhausted") return e.message || "That's a lot of feedback in a short time. Please wait a few minutes and try again.";
  if (code === "invalid-argument") return e.message || "Something in the form isn't right. Check it and try again.";
  if (code === "permission-denied") return e.message || "This account can't send feedback.";
  if (code === "unauthenticated") return "You're signed out. Sign in again, then send it.";
  return "Couldn't send it. Check the connection and try again; what you wrote is still here.";
}
